import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TResponse } from '@shared/models'
import { AuthService, FirebaseFunctionsService } from '@shared/services';

@Component({
    'selector': 'app-account',
    'templateUrl': './account.page.html',
    'styleUrls': ['./account.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class AccountPage extends ViewBasePage implements OnInit, OnDestroy {
    constructor(private authService: AuthService,  injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_ACCOUNT);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-account-tour');
    }

    public onAccountProfileClick() {
        this.router.navigateByUrl('/account/accountProfile');
    }

    public onOrdersClick() {
        this.router.navigateByUrl('/account/orders');
    }

    public async onDeleteAccountClick(): Promise<void> {
        // Actually we won't delete the account, we will only disable the current user from logging in again.
        const email = this.sessionService.getCurrentUser().email;
        const fullName = this.sessionService.getUsersFullName;
        let question = `Are you sure you want to delete the account associated with the current logged in user: `;
        question += `${fullName} and email ${email} ?`;

        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            await this.uxHelperService.showSpinner('Deleting Account.');
            await this.firebaseFunctionsService.disableUser(email);
            await this.uxHelperService.hideSpinner();

            const msg = 'You are no longer allowed to login.  Goodbye, we wish you well.';
            await this.uxHelperService.showAlert('Inforation', msg);
            await this.authService.logout();
            this.router.navigateByUrl('/welcome');
            window.location.reload();
        }
    }
}
